import { gql } from '@apollo/client';

export const getBusinessUserDetailsInfo = gql`
  query getBusinessUserDetailsInfo($id: String!) {
    SalesforceManagement {
      entities {
        businessUser(id: $id) {
          queries {
            salesforceManagement {
              relatedUsers {
                createdBy_firstName
                createdBy_lastName
                modifiedBy_firstName
                modifiedBy_lastName
              }
            }
          }
          views {
            SalesforceManagement_all {
              properties {
                Code
                Status
                IsAdmin
                Type {
                  Id
                  Title
                }
                Account
                Access {
                  Id
                  Title
                }
                createdOn
                createdBy
                modifiedOn
                modifiedBy
                AllowPolicyEndDateEdits
                AllowPlanCoverEdits
                AllowClauseEdits
                AllowGroupPolicy
                AllowEndorsement
                AllowEndorsementCostEdits
                AllowPolicyCorrection
                EditableLineChargesIDs {
                  views {
                    PlanConfigManagement_all {
                      properties {
                        Id
                        Name
                      }
                    }
                  }
                }
                PersonID {
                  id
                  views {
                    SalesforceManagement_all {
                      properties {
                        FullName
                        Email
                        PersonCode
                        DateOfBirth
                        PhoneDetails {
                          PhoneType
                          PhoneNumber
                        }
                        IsTaxable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export function getBusinessPartnersList() {
  return gql`
    query getBusinessPartnersList(
      $currentPage: Int!
      $currentPageSize: Int!
      $selectedBusinessUserID: String
    ) {
      SalesforceManagement {
        queries {
          getAssignedBPList(
            pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
            selectedBusinessUserID: $selectedBusinessUserID
          ) {
            paging {
              pageSize
              pageNumber
              totalCount
            }
            items {
              salesforceManagement_AssignedBP_Id
              businessPartner_Id
              businessPartner_PersonID {
                id
                views {
                  SalesforceManagement_all {
                    properties {
                      FullName
                    }
                  }
                }
              }
              salesforceManagement_AssignedBP_BusinessUserID {
                id
              }
              salesforceManagement_AssignedBP_BusinessPartnerID {
                id
              }
            }
          }
        }
      }
    }
  `;
}
